import { MutationKey, useQueryClient } from "@tanstack/react-query";
import { WaterfallRunPrefOnDebtDataRequest } from "gen/model/waterfallRunPrefOnDebtDataRequest";
import { useDeepCompareMemo } from "use-deep-compare";

export const WATERFALL_RUN_MUTATION_KEY: MutationKey = ["waterfallRun"];

export interface CreateAndRunWaterfallVars {
  fundFamilyId: string;
  fundFamilyEventId: string;
  fundFamilySubEventId: string;
  fundEntityId: string;
  data: WaterfallRunPrefOnDebtDataRequest;
}

export const useWaterfallFundFamilySubEventIds = () => {
  const queryClient = useQueryClient();
  const eventIds = queryClient
    .getMutationCache()
    .findAll({
      status: "pending",
      mutationKey: WATERFALL_RUN_MUTATION_KEY,
    })
    .map(
      (m) =>
        (m.state.variables as unknown as CreateAndRunWaterfallVars)
          .fundFamilySubEventId,
    )
    .filter(Boolean);
  return useDeepCompareMemo(() => eventIds, [eventIds]);
};
